const emojiImages = new Map();
const loadedEmojiImages = new Set();

export function preloadEmojiImage(url) {
  if (!url) return Promise.resolve(false);
  if (emojiImages.has(url)) return emojiImages.get(url);

  const promise = new Promise((resolve) => {
    const image = new globalThis.Image();
    const timeout = globalThis.setTimeout(() => {
      image.onload = null;
      image.onerror = null;
      emojiImages.delete(url);
      resolve(false);
    }, 2500);

    image.onload = async () => {
      globalThis.clearTimeout(timeout);
      try {
        await image.decode();
      } catch {
        // A completed image is still safe to display when decode is unavailable.
      }

      loadedEmojiImages.add(url);
      resolve(true);
    };

    image.onerror = () => {
      globalThis.clearTimeout(timeout);
      emojiImages.delete(url);
      resolve(false);
    };

    image.src = url;
  });

  emojiImages.set(url, promise);
  return promise;
}

export function hasPreloadedEmojiImage(url) {
  return Boolean(url && loadedEmojiImages.has(url));
}
